module.exports = __webpack_public_path__ + "static/img/journey.641b85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journey.png
// module id = Lg3I
// module chunks = 15 46